export default __webpack_public_path__ + "assets/fonts/2d596236c36ea94f01d912f0df7bfdac.woff";